module.exports = __webpack_public_path__ + "img/illustration_mobile_ch.2ab6e2e9.png";